module.exports = __webpack_public_path__ + "static/media/MHV-logo.7fe536c0.png";